export const UserRole = {
    Admin: 'Admin',
    AccountAdmin: 'Account Admin',
    SalesAppOnly: 'Sales-App Only',
    Max: 'MAX',
    HideSummaryReports: 'Hide Summary Reports',
    NearmapDisabled: 'nearmap-disabled',
    SketchTech: 'sketch-tech',
    SketchOsAdmin: 'sketchos-admin',
    SketchOsEnabled: 'sketchos-enabled',
    SketchOsExpSketchToolEnabled: 'sketchos-exp-sketchtool-enabled'
};

export const UserRoleId = {
    Admin: 1,
    AccountAdmin: 2,
    SalesAppOnly: 3,
    Max: 5,
    HideSummaryReports: 6,
    NearmapDisabled: 7,
    SketchTech: 8,
    SketchOsAdmin: 9,
    SketchOsEnabled: 10,
    SketchOsExpSketchToolEnabled: 11,
};

export default UserRole;
